// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-data-table.disabled{opacity:.5;pointer-events:none}.subData{color:#929292;font-size:12px!important;white-space:nowrap}.hr-sect{display:flex;flex-basis:100%;align-items:center;color:rgba(0,0,0,.35);font-weight:700;margin:8px 0}.hr-sect:after,.hr-sect:before{content:\"\";flex-grow:1;background:rgba(0,0,0,.35);height:1px;font-size:0;line-height:0;margin:0 8px}.fix-margin{margin-top:-14px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
